import { Link, useLocation, useNavigate } from "react-router-dom";
import { LogOut, Settings, KeyRound, Clock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Avatar } from "./BrandMark";

export default function TopBar() {
    const { user, logout } = useAuth();
    const loc = useLocation();
    const nav = useNavigate();
    const onSettings = loc.pathname.startsWith("/settings");
    const onActivity = loc.pathname.startsWith("/activity");
    const isAdmin = user && user.access_level === "admin";
    const forced = !!user?.must_change_password;

    return (
        <header
            data-testid="top-bar"
            className="fixed top-0 left-0 right-0 z-40 bg-white border-b flex items-center justify-between px-6"
            style={{ height: 62, borderColor: "var(--tms-border)" }}
        >
            <Link to="/" className="flex items-center gap-3 no-underline">
                <div
                    className="brand-mark brand-mark-md"
                    style={{ background: "var(--tms-navy)" }}
                    aria-hidden
                >
                    ES
                </div>
                <div className="flex flex-col leading-tight">
                    <span
                        style={{
                            color: "var(--tms-navy)",
                            fontWeight: 600,
                            fontSize: 16,
                        }}
                    >
                        Email Snippet Manager
                    </span>
                    <span
                        style={{
                            color: "var(--tms-green-dark)",
                            fontSize: 10,
                            fontWeight: 600,
                            letterSpacing: "0.14em",
                            textTransform: "uppercase",
                        }}
                    >
                        Email template library
                    </span>
                </div>
            </Link>

            <div className="flex items-center gap-3">
                {isAdmin && !forced && (
                    <button
                        data-testid="activity-nav-btn"
                        onClick={() => nav("/activity")}
                        className={onActivity ? "btn-primary-navy" : "btn-outline"}
                        title="Activity log"
                        aria-label="Activity log"
                    >
                        <Clock size={16} /> <span className="hidden sm:inline">Activity</span>
                    </button>
                )}
                {isAdmin && !forced && (
                    <button
                        data-testid="settings-nav-btn"
                        onClick={() => nav("/settings")}
                        className={onSettings ? "btn-primary-navy" : "btn-outline"}
                        title="Settings"
                        aria-label="Settings"
                    >
                        <Settings size={16} /> <span className="hidden sm:inline">Settings</span>
                    </button>
                )}
                {!forced && (
                    <button
                        data-testid="change-password-nav-btn"
                        onClick={() => nav("/change-password")}
                        className="btn-ghost"
                        title="Change password"
                    >
                        <KeyRound size={14} /> <span className="hidden md:inline">Change password</span>
                    </button>
                )}

                <div className="flex items-center gap-2 pl-3 border-l" style={{ borderColor: "var(--tms-border)" }}>
                    <Avatar initials={user?.initials} name={user?.name} size="md" />
                    <div className="hidden md:flex flex-col leading-tight">
                        <span style={{ fontSize: 13, fontWeight: 600, color: "var(--tms-navy)" }} data-testid="current-user-name">
                            {user?.name}
                        </span>
                        <span style={{ fontSize: 11, color: "var(--tms-muted)" }}>{user?.role_title}</span>
                    </div>
                </div>

                <button
                    data-testid="sign-out-btn"
                    onClick={logout}
                    className="btn-ghost"
                    title="Sign out"
                >
                    <LogOut size={15} /> <span className="hidden sm:inline">Sign out</span>
                </button>
            </div>
        </header>
    );
}
